<template>
  <el-dialog :visible.sync="dialogVisible" width="980px" :showClose="false">
    <div slot="title" class="title_box">
      <div style="font-size: 16px;color: #262f43;font-weight: 600;width: 90%;line-height: 1.5em">
        {{ productInfo.pkgProductName }}
      </div>
      <i class="el-icon-close" style="font-size: 20px;cursor: pointer" @click="dialogVisible = false"/>
    </div>
    <div class="x_body">
      <div v-for="(item, index) in productInfo.xItems" :key="index" class="x_item">
        <div class="x_item_head">
          <div class="x_item_head_title">
            <div class="x_index">{{ index + 1 }}</div>
            <div>{{ item.name }}</div>
          </div>
          <div style="color: #3a7dfa">份数: {{ item.quantity }}份</div>
        </div>
        <div class="x_item_body">
          <div class="basic_box">
            <div class="item">
              <div class="title">
                <i class="iconfont icon-caidan"/>
                <span>菜单</span>
              </div>
              <div class="desc interval">{{ getMenu(item.menus) }}</div>
            </div>
            <div class="item">
              <div class="title">
                <i class="iconfont icon-ruzhurenshu1"/>
                <span>适用人数</span>
              </div>
              <div class="desc" v-if="item.auditNum || item.childNum">
                <span>{{ item.auditNum ? `${item.auditNum}成人` : '' }}</span>
                <span>{{ item.childNum ? ` ${item.childNum}儿童` : '' }}</span>
              </div>
              <div class="desc" v-else>
                无
              </div>
            </div>
          </div>
          <div class="basic_box">
            <div class="item">
              <div class="title">
                <i class="el-icon-time"/>
                <span>接待时间</span>
              </div>
              <div class="desc interval" v-if="item.receptionTimes && item.receptionTimes.length">
                <div class="desc" v-if="item.receptionTimes && item.receptionTimes.length">
                  <span v-for="(p, i) in item.receptionTimes" :key="i">{{
                      p
                    }}{{ i < item.receptionTimes.length - 1 ? '、' : '' }}</span>
                </div>
              </div>
              <div class="desc" v-else>
                无
              </div>
            </div>
            <div class="item">
              <div class="title">
                <i class="iconfont icon-yuyueguize"/>
                <span>预约规则</span>
              </div>
              <div class="desc">{{ getRules(item.appointType, item.appointValue) }}</div>
            </div>
          </div>
          <div class="long_item">
            <div class="title">
              <i class="iconfont icon-lianxidianhua"/>
              <span>联系电话</span>
            </div>
            <div class="desc" v-if="item.bookingPhones && item.bookingPhones.length">
              <span v-for="(p, i) in item.bookingPhones" :key="i">{{ p }}{{
                  i < item.bookingPhones.length - 1 ? '、' : ''
                }}</span>
            </div>
            <div class="desc" v-else>
              无
            </div>
          </div>
          <div class="long_item">
            <div class="title">
              <i class="iconfont icon--duanlashuoming"/>
              <span>规则说明</span>
            </div>
            <div class="desc">{{ item.ticketUseSiteDesc ? item.ticketUseSiteDesc : '无' }}</div>
          </div>
          <div class="long_item">
            <div class="title">
              <i class="iconfont icon-liwuhuodong"/>
              <div>特别补充</div>
            </div>
            <div class="desc">{{ item.freeStyleDesc ? item.freeStyleDesc : '无' }}</div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'productDialog',
  data () {
    return {
      productInfo: {},
      dialogVisible: false
    }
  },
  methods: {
    init (productInfo) {
      this.productInfo = productInfo
      this.dialogVisible = true
    },
    getRules (appointType, appointValue) {
      if (appointType === 0) {
        return '无需预约'
      } else if (appointType === 1) {
        return '需要提前预约'
      } else if (appointType === 2) {
        return `提前${appointValue}天预约`
      } else if (appointType === 3) {
        return `提前${appointValue}小时预约`
      } else {
        return '无'
      }
    },
    getMenu (menus) {
      if (!menus) return '无'
      if (menus && menus.length && menus[0].detail && menus[0].detail.length) {
        return menus[0].detail[0].name ? menus[0].detail[0].name : '无'
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog__title {
  color: #262f43;
  font-size: 14px;
  line-height: 30px;
}

/deep/ .el-dialog__header {
  background-color: #fff;
  padding: 0;
}

/deep/ .el-dialog {
  border-radius: 7px;
}

/deep/ .el-dialog__body {
  padding: 35px 15px;
}

/deep/ .el-dialog__header {
  height: auto !important;
}

/deep/ .el-dialog__body {
  padding-top: 0 !important;
}

.title_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
}

.x_body {
  max-height: 680px;
  overflow: scroll;
}

.x_item {
  margin-top: 20px;
  border: 1px solid #e0e8f5;
  border-radius: 4px;
  box-shadow: 2px 4px 10px #e9eff5;

  &_head {
    background-color: #f3f7fd;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #262f43;

    &_title {
      display: flex;
      align-items: center;
      column-gap: 8px;
      font-weight: 600;
    }

    .x_index {
      background-color: #256af7;
      color: #fff;
      padding: 6px 8px;
      border-radius: 4px;
    }
  }

  &_body {
    padding: 15px;
    font-size: 13px;

    .long_item {
      display: flex;
      justify-content: space-between;
      padding: 15px 0;

      &:not(:last-child) {
        border-bottom: 1px dashed #dbdbe7;
      }

      .title {
        width: 90px !important;
        display: flex;
        align-items: center;
        word-break: keep-all;

        i {
          color: #256af7;
        }
      }

      .desc {
        width: 820px;
        display: flex;
        align-items: center;
        line-height: 1.3em;
      }
    }

    .basic_box {
      display: flex;
      justify-content: space-between;

      .item {
        width: 49%;
        display: flex;
        padding: 15px 0;
        border-bottom: 1px dashed #dbdbe7;
        position: relative;

        .title {
          width: 90px;

          i {
            color: #256af7;
          }
        }

        .desc {
          display: flex;
          align-items: center;

          &.interval::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 47px;
            background-color: #d9d9e0;
            position: absolute;
            top: 0;
            right: -9px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/productDialog.vue